<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            :main-title="this.$t('badgeGallery.section1.texts.text1-1')"
            :sub-title="this.$t('badgeGallery.section1.texts.text1-2')"
            bg-color=""
        />

        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <!-- ANCHOR: Search  -->
                <div class="d-flex justify-end">
                    <v-text-field
                        v-model="search"
                        outlined
                        :dense="$vuetify.breakpoint.mdAndUp"
                        :class="{ 'xsmall': $vuetify.breakpoint.smAndDown }"
                        style="max-width: 240px;"
                        hide-details
                        :placeholder="this.$t('badgeGallery.section1.texts.text2-1')"
                        color="blue1"
                    >
                        <template v-slot:append>
                            <button
                                v-if="search"
                                @click="clearSearch"
                            >
                                <v-icon>fontagon-icons ft-icon ft-ic_delete</v-icon>
                            </button>

                            <v-icon
                                class="search-icon"
                            >
                                fontagon-icons ft-icon ft-ic_search
                            </v-icon>
                        </template>
                    </v-text-field>
                </div>
                <!-- // search  -->

                <!-- ANCHOR: Tab -->
                <div
                    class="tab-container"
                    :class="{ 'mt-10': $vuetify.breakpoint.mdAndUp, 'mt-8': $vuetify.breakpoint.smAndDown, 'mb-25': $vuetify.breakpoint.mdAndUp, 'mb-15': $vuetify.breakpoint.smAndDown }"
                >
                    <swiper
                        v-if="false"
                        :options="swiperBoardTab"
                        class="tab tab-space-1"
                    >
                        <swiper-slide class="tab__item">
                            <router-link
                                :to="{ name: 'BadgesGalleryPage', query: { category: 'all' } }"
                                class="tab__link"
                                :class="[ selectdCategory == 'all' ? 'active' : '' ]"
                                @click.native="fetchDataForSelectedCategory('')"
                            >
                                {{ $t('badgeGallery.section1.btns.btn1') }}
                            </router-link>
                        </swiper-slide>

                        <swiper-slide class="tab__item">
                            <router-link
                                :to="{ name: 'BadgesGalleryPage', query: { category: 'edu' } }"
                                class="tab__link"
                                :class="[ selectdCategory == 'edu' ? 'active' : '' ]"
                                @click.native="fetchDataForSelectedCategory('edu')"
                            >
                                {{ $t('badgeGallery.section1.btns.btn2') }}
                            </router-link>
                        </swiper-slide>

                        <swiper-slide class="tab__item">
                            <router-link
                                :to="{ name: 'BadgesGalleryPage', query: { category: 'corp' } }"
                                class="tab__link"
                                :class="[ selectdCategory == 'corp' ? 'active' : '' ]"
                                @click.native="fetchDataForSelectedCategory('corp')"
                            >
                                {{ $t('badgeGallery.section1.btns.btn3') }}
                            </router-link>
                        </swiper-slide>

                        <swiper-slide class="tab__item">
                            <router-link
                                :to="{ name: 'BadgesGalleryPage', query: { category: 'group' } }"
                                class="tab__link"
                                :class="[ selectdCategory == 'group' ? 'active' : '' ]"
                                @click.native="fetchDataForSelectedCategory('group')"
                            >
                                {{ $t('badgeGallery.section1.btns.btn4') }}
                            </router-link>
                        </swiper-slide>

                        <swiper-slide class="tab__item">
                            <router-link
                                :to="{ name: 'BadgesGalleryPage', query: { category: 'etc' } }"
                                class="tab__link"
                                :class="[ selectdCategory == 'etc' ? 'active' : '' ]"
                                @click.native="fetchDataForSelectedCategory('etc')"
                            >
                                {{ $t('badgeGallery.section1.btns.btn5') }}
                            </router-link>
                        </swiper-slide>
                    </swiper>

                    <swiper
                        :options="swiperBoardTab"
                        class="tab tab-space-1"
                    >
                        <swiper-slide
                            v-for="(tab, index) in tabs"
                            :key="index"
                            class="tab__item"
                        >
                            <router-link
                                :to="tab.route"
                                class="tab__link"
                                :class="{ active: selectdCategory === tab.category }"
                                @click.native="updateCategoryAndFilter"
                            >
                                {{ tab.label }}
                            </router-link>
                        </swiper-slide>
                    </swiper>
                </div>
                <!-- // tab -->

                <template v-if="getBadgeList.length">
                    <!-- ANCHOR: 검색 결과가 없을 때 표시할 메시지 -->
                    <div
                        v-if="getBadgeList.length > 0 && filteredBadges.length === 0"
                        class="text-center board-list-space le-text-body2"
                    >
                        {{ $t('badgeGallery.section1.texts.text3-1') }}
                    </div>
                    <!-- // 검색 결과가 없을 때 표시할 메시지 -->

                    <!-- ANCHOR: 게시물이 없을 때 표시할 메시지 -->
                    <div
                        v-if="getBadgeList.length === 0"
                        class="no-data"
                    >
                        {{ $t('board.noData') }}
                    </div>
                    <!-- // 게시물이 없을 때 표시할 메시지 -->

                    <!-- ANCHOR: BoardList -->
                    <ul
                        v-if="filteredBadges.length > 0"
                        class="board-list board-list-space"
                    >
                        <li
                            v-for="item in filteredBadges"
                            :key="item.id"
                            class="board-list__item"
                        >
                            <div
                                class="catetory-name"
                                :class="{ 'catetory-name--green': item.category === 'corp', 'catetory-name--blue': item.category === 'edu', 'catetory-name--orange': item.category === 'group', 'catetory-name--grey': item.category === 'grey' }"
                            >
                                <template v-if="item.category === 'edu'">
                                    {{ $t('badgeGallery.section1.btns.btn2') }}
                                </template>

                                <template v-else-if="item.category === 'corp'">
                                    {{ $t('badgeGallery.section1.btns.btn3') }}
                                </template>

                                <template v-else-if="item.category === 'group'">
                                    {{ $t('badgeGallery.section1.btns.btn4') }}
                                </template>

                                <template v-else>
                                    {{ $t('badgeGallery.section1.btns.btn5') }}
                                </template>
                            </div>
                        
                            <div class="board-list__box">
                                <div class="board-list__thumb">
                                    <a
                                        :href="item.badgeLinkUrl"
                                        target="_blank"
                                    >
                                        <img :src="`${imageBaseUrl}${item.badgeImagePath}`">
                                    </a>
                                </div>

                                <div class="board-list__info">
                                    <div class="board-list__title">
                                        {{ item.badgeTitle }}
                                    </div>

                                    <div class="board-list__issuer">
                                        <a
                                            :href="item.issuerLinkUrl"
                                            target="_blank"
                                        >{{ item.issuerName }}</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                <!-- // board-list -->
                </template>

                <template v-else>
                    <div class="d-flex justify-center">
                        <v-progress-circular
                            indeterminate
                            color="#FF6442"
                            size="60"
                            width="10"
                        ></v-progress-circular>
                    </div>
                </template>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { getBadgesGalleryMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
    name: 'BadgesGalleryPage',
    components: {
        PageTitle,
        Swiper,
        SwiperSlide
    },

    // metaInfo() {
    //     return getBadgesGalleryMetaInfo(this);
    // },

    // SECTION: Data Properties
    data: function () {
        return {
            selectdCategory: this.$route.query.category || 'all',
            isBoardData: null,

            swiperBoardTab: {
                freeMode: true,
                direction: 'horizontal',
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 0,
            },
            tabs: [
                { label: this.$t('badgeGallery.section1.btns.btn1'), category: 'all', route: { name: 'BadgesGalleryPage', query: { category: 'all' } } },
                { label: this.$t('badgeGallery.section1.btns.btn2'), category: 'edu', route: { name: 'BadgesGalleryPage', query: { category: 'edu' } } },
                { label: this.$t('badgeGallery.section1.btns.btn3'), category: 'corp', route: { name: 'BadgesGalleryPage', query: { category: 'corp' } } },
                { label: this.$t('badgeGallery.section1.btns.btn4'), category: 'group', route: { name: 'BadgesGalleryPage', query: { category: 'group' } } },
                { label: this.$t('badgeGallery.section1.btns.btn5'), category: 'etc', route: { name: 'BadgesGalleryPage', query: { category: 'etc' } } }
            ],

            search: this.$route.query.search || '', // 검색어
            hasResults: false, // 검색 결과의 존재 여부
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    computed: {
        ...mapGetters('badgeGallery', ['getBadgeList']),

        imageBaseUrl() {
            return process.env.VUE_APP_IMAGE_BASE_URL || '';
        },

        filteredBadges() {
            const search = this.search.toLowerCase();

            if (!Array.isArray(this.getBadgeList)) {
                return [];
            }

            return this.getBadgeList.filter(item => {
                const combined = (item.badgeTitle + ' ' + item.issuerName).toLowerCase();
                return combined.includes(search);
            });
        }
    },

    watch: {
        $route(to, form) {
            if (to.query !== form.query) {
                this.selectdCategory = to.query.category || 'all';
                this.search = to.query.search || '';
                this.fetchBadgeGalleryList(this.selectdCategory);
            }
        },

        search() {
            this.updateQuery();
        },
    },

    created() {
        //
    },

    mounted() {
        this.fetchBadgeGalleryList(this.selectdCategory);
    },

    beforeDestroy() {
        //
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        ...mapActions(
            'badgeGallery', [ 'fetchBadgeGalleryList' ]
        ),

        /* ============================================================
         * ANCHOR: 주석
         * ============================================================ */
        // Tab 버튼을 클릭하여 카테고리 조회
        fetchDataForSelectedCategory(category) {
            this.fetchBadgeGalleryList(category);
        },

        updateCategoryAndFilter() {
            const boardListDataLength = document.querySelectorAll('.board-list li').length;
            this.isBoardData = boardListDataLength == 0;
            this.search = '';
            this.updateQuery();
        },

        shouldShowBadge(completeText) {
            const search = this.search.toLowerCase();
            const completeTextLower = completeText.toLowerCase();

            // 정규 표현식을 사용하여 연속된 문자열 검색
            const regex = new RegExp(search, 'i'); // 'i' 옵션은 대소문자를 무시하도록 설정
            return regex.test(completeTextLower);
        },        

        clearSearch() {
            this.search = '';
        },

        updateQuery() {
            // URL 쿼리 문자열을 업데이트
            this.$router.push({
                query: {
                    category: this.selectdCategory,
                    search: this.search || '', // 검색어 업데이트
                },
            }).catch(()=>{});
        }
    },
    // !SECTION: Methods
};
</script>
